if (!customElements.get("product-feed")) {
  customElements.define("product-feed", class extends HTMLElement {
    constructor() {
      super();

      this.source = this.getAttribute("source");
    }

    connectedCallback() {
      switch (this.source) {
        case "recently-viewed":
          this.renderRecentlyViewed();
          break;
        case "favorites":
          this.renderFavorites();
          break;
        case "you-may-also-like":
          this.renderYouMayAlsoLike();
          break;
        case "top-sellers":
          this.renderTopSellers();
          break;
        default:
          console.warn(`Unknown source: ${this.source}`);
      }
    }

    get productFeedContainer() {
      return this.querySelector("[product-feed-container]");
    }

    reinitCarousel() {
      const carouselSlider = this.querySelector("carousel-slider");
      if (carouselSlider) {
        carouselSlider.refresh();
      }
    }

    renderProducts(products) {
      products.forEach((product, index) => {
        const sliderItem = document.createElement("div");
        sliderItem.classList.add("slider__item");

        const productFeedItem =
          document.createElement("product-feed-item");
        productFeedItem.setAttribute("product-url", product.url);

        if (index === 0) {
          productFeedItem.setAttribute("is-first", "true");
        }

        if (index === products.length - 1) {
          productFeedItem.setAttribute("is-last", "true");
        }

        sliderItem.appendChild(productFeedItem);
        this.productFeedContainer.appendChild(sliderItem);
      });

      this.reinitCarousel();
    }

    renderFallbackProducts() {
      const productFeedTitle = this.querySelector(
        "[data-product-feed-title]"
      );
      const productFeedTitleMobile = this.querySelector(
        "[data-product-feed-title-mobile]"
      );
      const productFeedSubtitle = this.querySelector(
        "[data-product-feed-subtitle]"
      );
      const productFeedSubtitleMobile = this.querySelector(
        "[data-product-feed-subtitle-mobile]"
      );
      const fallbackTitle = this.getAttribute("fallback-title");
      const fallbackTitleMobile = this.getAttribute("fallback-title-mobile");
      const fallbackSubtitle = this.getAttribute("fallback-subtitle");
      const fallbackSubtitleMobile = this.getAttribute("fallback-subtitle-mobile");

      if (fallbackTitle && productFeedTitle) {
        productFeedTitle.textContent = fallbackTitle;
      }

      if (fallbackTitleMobile && productFeedTitleMobile) {
        productFeedTitleMobile.textContent = fallbackTitleMobile;
      }

      if (fallbackSubtitle && productFeedSubtitle) {
        productFeedSubtitle.textContent = fallbackSubtitle;
      }

      if (fallbackSubtitleMobile && productFeedSubtitleMobile) {
        productFeedSubtitleMobile.textContent = fallbackSubtitleMobile;
      }

      const fallbackProductsTemplate = this.querySelector(
        'template[name="fallback-products"]'
      );
      if (!fallbackProductsTemplate) {
        this.remove();
        return;
      }

      const productSliderItems =
        fallbackProductsTemplate.content.querySelectorAll(
          ".slider__item"
        );

      productSliderItems.forEach((item) => {
        this.productFeedContainer.appendChild(item);
      });

      // Remove skeleton items
      const skeletonItems = this.productFeedContainer.querySelectorAll(
        ".skeleton-item"
      );
      skeletonItems.forEach((item) => item.remove());

      this.reinitCarousel();
    }

    renderTopSellers() {
      // Get product type from data attribute
      const productType = this.getAttribute("product-type") || "";
      const baseUrl =
        "https://gw-12tribe-routes-d5a3583c44f9.herokuapp.com/top-sellers";
      const apiUrl = productType
        ? `${baseUrl}/${productType}`
        : baseUrl;

      fetch(apiUrl, { priority: "low" })
        .then((response) => response.json())
        .then((data) => {
          // Check if we have enough products
          if (!data || data.length < 4) {
            this.renderFallbackProducts();
            return;
          }

          const baseShopUrl = window.location.origin;
          const products = data.products.map((product) => ({
            url: `${baseShopUrl}/products/${product.handle}`,
          }));

          this.renderProducts(products);
        })
        .catch((error) => {
          console.error("Error fetching top sellers:", error);
          this.renderFallbackProducts();
        });
    }

    renderRecentlyViewed() {
      const recentlyViewedData =
        JSON.parse(
          localStorage.getItem("recentlyViewedProducts")
        ) || [];
      const recentlyViewedProducts =
        recentlyViewedData.filter(Boolean);

      if (!recentlyViewedProducts.length) {
        this.renderFallbackProducts();
        return;
      }

      const baseUrl = window.location.origin;
      const products = recentlyViewedProducts.map((productHandle) => {
        return {
          url: `${baseUrl}/products/${productHandle}`,
        };
      });

      this.renderProducts(products);
    }

    renderFavorites() {
      const swymData =
        JSON.parse(localStorage.getItem("swym-products")) || [];
      const swymAllProducts = swymData?.all?.splice(0, 10) || [];

      if (!swymAllProducts.length) {
        this.renderFallbackProducts();
        return;
      }

      const products = swymAllProducts.map((product) => ({
        url: product.du,
      }));

      this.renderProducts(products);
    }

    renderYouMayAlsoLike() {
      fetch(this.dataset.ymalUrl, { priority: "low" })
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const updatedCarouselSlider =
            html.querySelector("carousel-slider");
          const currentCarouselSlider =
            this.querySelector("carousel-slider");

          currentCarouselSlider.replaceWith(
            updatedCarouselSlider
          );
        });
    }
  }
  );
}

if (!customElements.get("product-feed-item")) {
  customElements.define(
    "product-feed-item",
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.productUrl = this.getAttribute("product-url");
        this.fetchProductCard(this.productUrl);
      }

      fetchProductCard(url) {
        const sectionUrl = new URL(url);
        sectionUrl.searchParams.set("section_id", "product-card");

        fetch(sectionUrl, { priority: "low" })
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(
              text,
              "text/html"
            );
            
            const productFeed = this.closest("product-feed");
            const carouselSlider = this.closest("carousel-slider");
            const productCard = html.querySelector("product-block");

            // Filter product card, add remove any product that contains "recentlyviewed-hidden" tag

            if (productFeed) {
              const isRecentlyViewedProductFeed = productFeed.getAttribute("source") === "recently-viewed";
              if (isRecentlyViewedProductFeed) {
                const productTags = productCard.getAttribute("data-item-tags");
                if (productTags.includes("recentlyviewed-hidden")) {
                  const sliderItem = this.closest(".slider__item");
                  const skeletonItem = carouselSlider.querySelector(
                    ".skeleton-item"
                  );
                  
                  if (skeletonItem) {
                    skeletonItem.remove();
                  }

                  if (this.hasAttribute("is-last")) {
                    const skeletonItems = carouselSlider.querySelectorAll(
                      ".skeleton-item"
                    );
                    skeletonItems.forEach((item) => item.remove());
                  }

                  if (sliderItem) {
                    sliderItem.remove();
                  } else {
                    this.remove();
                  }

                  return;
                }
              }
            }

            if (productCard) {
              this.prepend(productCard);
            }

            // Remove skeleton item
            const skeletonItem = carouselSlider.querySelector(
              ".skeleton-item"
            );
            if (skeletonItem) {
              skeletonItem.remove();
            }

            if (this.hasAttribute("is-last")) {
              // Remove skeleton items
              const skeletonItems = carouselSlider.querySelectorAll(
                ".skeleton-item"
              );
              skeletonItems.forEach((item) => item.remove());
            }

            if (!productCard) {
              const sliderItem = this.closest(".slider__item");
              if (sliderItem) {
                sliderItem.remove();
              } else {
                this.remove();
              }
            }
          })
          .catch((e) => {
            console.error(e);
          }).finally(() => {
            // Initialize Swym widget
            function swymCallbackFn(swat) {
              swat.injectSwymButtonOnProductGrid()
            }

            if (!window.SwymCallbacks) {
              window.SwymCallbacks = [];
            }

            window.SwymCallbacks.push(swymCallbackFn);
          });
      }
    }
  );
}